module.exports = __webpack_public_path__ + "static/FiraCode-Light-ea5515d8a5db6cd96031c85afe59911d.otf";